import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appDropdownToggle]',
  exportAs: 'dropdownToggle',
  standalone: true,
})
export class DropdownToggleDirective {
  @HostBinding('class.open') isOpen = true;

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
